import React from 'react';
import { Box, Typography, IconButton, Tooltip } from '@mui/material';
import { HelpOutline as HelpIcon } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

export interface PageHeaderProps {
  title: string;
  subtitle?: string;
  helpLink?: string;
  helpTooltip?: string;
  actions?: React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  helpLink,
  helpTooltip = 'Learn more',
  actions,
}) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: subtitle ? 1 : 3 }}>
      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="h4" component="h1">
            {title}
          </Typography>
          {helpLink && (
            <Tooltip title={helpTooltip}>
              <IconButton
                component={RouterLink}
                to={helpLink}
                size="small"
                sx={{ color: 'text.secondary' }}
              >
                <HelpIcon />
              </IconButton>
            </Tooltip>
          )}
        </Box>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions && <Box>{actions}</Box>}
    </Box>
  );
};

export default PageHeader;
